import "../style/home/H_NewProduct.css";

// import img1 from "../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg";
// import img2 from '../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg'
// import img3 from "../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg";
import date_icon from "../../assets/store/calendar.png";
import hat_icon from "../../assets/store/teacher.png";
import type_icon from "../../assets/store/profile-2user.png";

// import as_bg_img from '../../assets/store/Group 148.png';

// import as_icon from '../../assets/store/discount-shape.png';
import { BsHeart } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useState } from "react";
import { Link } from "react-router-dom";
import bag_icon from "../../assets/store/Group 127.png";
import moment from "jalali-moment";

// let data = [
//   {
//     id: 1,
//     img: img1,
//     title: "آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price: "450.200",
//     discounted_price: "405.000",
//     discount: "10%",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "discounted",
//     user_num: 100,
//   },
//   {
//     id: 2,
//     img: img3,
//     title: "آزمون زیست شناسی دهم",
//     // price:458.200,
//     price: "350.000",
//     discounted_price: "305.000",
//     discount: "10%",
//     date: "28 آبان 1400",
//     level: "کارشناسی",
//     type: "گروهی",
//     filter: "discounted",
//     user_num: 100,
//   },
//   {
//     id: 3,
//     img: img1,
//     title: "آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price: "350.200",
//     discounted_price: "305.000",
//     discount: "10%",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "discounted",
//     user_num: 100,
//   },
//   {
//     id: 4,
//     img: img3,
//     title: "آزمون روان درمانی اگزیستانسیال",
//     // price:458.200,
//     price: "458.200",
//     discounted_price: "",
//     discount: "",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "none",
//     user_num: 100,
//   },
// ];

const H_NewProduct = () => {
  const state = useSelector((state) => state.default);

  let filter_data = state.ExamData.filter((item,index) => index < 4);
  const [data] = useState(filter_data);

  moment.locale("en");
  return (
    <div className="h-new-product">
      <div className="h-new-produc-title">جدیدترین آزمون‌ها</div>
      <div className="h-new-product-content">
        {data.map((item) => (
          <div key={item.id} className="as-item">
            <div className="as-item-img">
              <img src={item.img} alt="product-img" />
              <div className="spcp-item-img-cover"></div>
              <Link
                to={`/dashboard/store/${item.id}`}
                className="as-item-img-bag-icon"
              >
                <img src={bag_icon} alt="bag-icon" />
                <div className="as-item-img-bag-icon-hover-text">
                  بررسی و خرید آزمون
                </div>
              </Link>
              <BsHeart className="as-item-img-heart-icon" />
              <div className="as-item-userNum-container">
                <div className="as-item-userNum">
                  <div className="as-item-userNum-item"></div>
                  <div className="as-item-userNum-item"></div>
                  <div className="as-item-userNum-item"></div>
                  <div className="as-item-userNum-item">+{item.count}</div>
                </div>
              </div>
            </div>
            <div className="as-item-title-and-price">
              <div className="as_item_img_withe_space"></div>
              <div className="as-itap-title">{item.name}</div>
              <div
                style={
                  item.badge ? { justifyContent: "space-between" } : null
                }
                className="as-itap-price"
              >
                <div
                  style={
                    item.badge
                      ? { color: "#888", textDecoration: "2px line-through" }
                      : null
                  }
                  className="as-itap-price-main"
                >
                  {item.masterPrice} <span className="as-itap-price-unit">تومان</span>
                </div>
                {item.badge && (
                  <div className="as-itap-price-discounted">
                    {item.price}{" "}
                    <span className="as-itap-price-unit">تومان</span>
                  </div>
                )}
                {item.badge && (
                  <div className="as-itap-price-discount">{item.badge}</div>
                )}
              </div>
            </div>
            <div className="as-item-info">
              <div className="as-item-info-date-box">
                <img src={date_icon} alt="date-icon" />
                <div className="as-iidb-text">
                  {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
                </div>
              </div>
              <div className="as-item-info-level-box">
                <img src={hat_icon} alt="hat-icon" />
                <div className="as-iilb-text">{item.level}</div>
              </div>
              <div className="as-item-info-type-box">
                <img src={type_icon} alt="type-icon" />
                <div className="as-iitb-text">
                  {item.type===1 && "انفرادی"}
                  {item.type===2 && "گروهی"}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="h-new-product-see-more-btn">
        <div className="h-new-psmb-line"></div>
        <div className="h-new-psmb-btn">مشاهده آزمون‌های بیشتر</div>
        <div className="h-new-psmb-line"></div>
      </div>
    </div>
  );
};

export default H_NewProduct;
